import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import * as jQuery from 'jquery';
import { Subject } from 'rxjs';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { CONSTANTS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { PrerollCreativeComponent } from '../preroll-creative/preroll-creative.component';

@Component({
	selector: 'app-radio-creative-r1',
	styleUrls: ['./radio-creative-r1.component.css'],
	templateUrl: './radio-creative-r1.component.html'
})
export class RadioCreativeR1Component extends PrerollCreativeComponent implements OnInit, AfterViewInit {
	@Input() downloadconfig: string;
	@Input() sectionclass: string;
	@ViewChild('audioTag') audioPlayer: any;
	public downloadConfiguration: DownloadConfig;
	public getStartTime: any;
	public getEndTime: any;
	public calcDuration: any;
	public requestSubscription: Subject<any>;
	public isR8: boolean = false;
	public isR104: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef
	) {
		super(analyticsService, analyticsDataModel, cdr);
		this.hasData = false;
		this.showLoad = true;
		this.requestData();
	}

	ngOnInit(): void {
		this.isR8 = this.analyticsDataModel.config.version === 'R8' ? true : false;
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = JSON.parse(decodeURI(this.downloadcsvcolumns));
		super.ngOnInit();
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

	requestData(): void {
		if (this.requestSubscription) {
			this.requestSubscription.unsubscribe();
		}
		setTimeout(() => {
			this.requestSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
				this.showLoad = false;
				if (res.success) {
					this.hasData = true;
					this.setData(res.data);
				} else {
					this.hasData = false;
				}
			});
		}, CONSTANTS.LOAD_TIME);
	}

	updateStatusBar(startPercent: number, equalDuration: any): void {
		jQuery('#preRollvideo')[0].currentTime = Math.floor(startPercent / 25) * equalDuration;
		jQuery('#preRollvideo')[0].play();
		this.getStartTime = 0;
		this.calcDuration = equalDuration - this.getStartTime;
		this.calcDuration = this.calcDuration * 1000;
		jQuery('#svg_0Percent').css({ backgroundColor: this.primaryColor, opacity: 0.07 });
		jQuery('#svg_0Percent').animate(
			{ opacity: 1.0 },
			{
				duration: this.calcDuration,
				easing: 'linear'
			}
		);
	}

	circleAudioClickEvent(typeOfPercent: any): void {
		if (this.setDisplayProperties.audioURL !== '') {
			const totalAudioDuration = this.audioPlayer.nativeElement.duration;
			const equalDuration = parseFloat(totalAudioDuration) / 4;
			const splitURL = this.setDisplayProperties.audioURL.split('#');
			this.setDisplayProperties.audioURL = splitURL[0];
			if (typeOfPercent === 0) {
				jQuery('#svg_0Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_25Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				this.updateStatusBar(typeOfPercent, equalDuration);
				jQuery('#svg_0Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_25Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
			} else if (typeOfPercent === 25) {
				this.updateStatusBar(typeOfPercent, equalDuration);
				jQuery('#svg_0Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
			} else if (typeOfPercent === 50) {
				this.updateStatusBar(typeOfPercent, equalDuration);
				jQuery('#svg_25Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
			} else if (typeOfPercent === 75) {
				this.updateStatusBar(typeOfPercent, equalDuration);
				jQuery('#svg_50Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
			} else if (typeOfPercent === 100) {
				const getCurrentTime = jQuery('#preRollvideo')[0].currentTime;
				const totDuration = jQuery('#preRollvideo')[0].duration;
				if (getCurrentTime < totDuration) {
					jQuery('#audio_svg_0Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
					jQuery('#audio_svg_25Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
					jQuery('#audio_svg_50Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
					jQuery('#audio_svg_75Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
					jQuery('#audio_svg_100Percent').css({ backgroundColor: this.primaryColor, color: this.primaryColor });
					this.updateStatusBar(typeOfPercent, equalDuration);
					jQuery('#percent0').css('color', 'black');
					jQuery('#percent25').css('color', 'black');
					jQuery('#percent50').css('color', 'black');
					jQuery('#percent75').css('color', 'black');
					jQuery('#percent100').css('color', 'black');
				}
				if (getCurrentTime >= totDuration) {
					jQuery('#svg_0Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
					jQuery('#svg_25Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
					jQuery('#svg_50Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
					jQuery('#svg_75Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
					jQuery('#svg_100Percent').css({ backgroundColor: this.defaultColor, color: this.primaryColor });
					this.updateStatusBar(typeOfPercent, equalDuration);
				}
			}
		}
	}
}
